// 批量注册ant-design-vue组件，按需加载

import elementUiCom from '@/components/element-ui/element-com'

const install = Vue => {
  Object.values(elementUiCom).forEach(item => {
    Vue.use(item)
  })
}

export default { install }
